import React from 'react';

import Comment from '../components/Product/Comments/Comment';
import {UserType} from '../shapes/user';


export const commentListItem = (
  childCommentId: number,
  mugshotImageUrl: string,
  userScreenName: string,
  deletedUsersComment: boolean,
  commentCreatedAt: Date,
  timeElapsedSinceCreation: string,
  usersComment: string,
  userType: UserType,
  userOwnsComment: boolean,
  handleDeleteComment: (commentId: number) => void,
  commentUserId?: number,
  commentParentId?: number,
): JSX.Element => (
  <li key={childCommentId} >
    <Comment
      imageSource={mugshotImageUrl}
      userName={userScreenName}
      deletedComment={deletedUsersComment}
      createdAt={commentCreatedAt}
      timeElapsedSinceCreation={timeElapsedSinceCreation}
      usersComment={usersComment}
      userId={commentUserId}
      userType={userType}
      parentId={commentParentId}
      commentId={childCommentId}
      userOwnsComment={userOwnsComment}
      deleteComment={handleDeleteComment}
    />
  </li>
);
